import styled from 'react-emotion';

export const Base = styled.article`
	align-items: flex-start;
	font-family: Roboto, Arial, lucida, helvetica, sans-serif;
	font-size: 1rem;
	display: flex;
	line-height: 1.5;
	flex-wrap: wrap;
	overflow: hidden;

	h1 {
		flex: 1 0 100%;
	} 

	& > * {
		flex: 1 0 50%;
	}

	a {
		color: inherit;
		text-decoration: underline;

		&:hover {
			text-decoration: none;
		}
	}

	button {
		cursor: pointer;
	}
	
	@media (max-width: 480px) {
		padding: 1em;
		& > * {
			flex: 1 0 100%;
		}
	}
`;

export const Left = styled.main`
	flex: 1 1 50%;

	@media (max-width: 900px) {
		flex: 1 0 100%;
	}

	@media (max-width: 480px) {
		width: 100%;
	}
`;

export const Right = styled.aside`
	background-color: #f2f2f2;
	border-bottom: 1px solid #d9d9d9;
	box-sizing: border-box;
	flex: 0 0 450px;
	margin-top: 1.315rem;
	margin-left: 2.5%;
	padding: 1rem;

	@media (max-width: 900px) {
		flex: 1 0 100%;
		margin: 0;
	}
`;

export const Clearfix = styled.div`
	clear: both;
	display: block;
	height: 0;
`
